<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" />
        <button @click="(event) => handleButtonPress(event)">New Work Order</button>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search" />
            <svg class="filterIcon" width="32" height="26" viewBox="0 0 32 26" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="4" fill="#699991" rx="2" />
              <rect x="8" y="22" width="16" height="4" fill="#699991" rx="2" />
              <rect x="4" y="11" width="24" height="4" fill="#699991" rx="2" />
            </svg>
          </div>
        </div>
        <DataTable v-bind:tableData="tableData" v-bind:configuration="selectedItem" v-bind:openModalCallback="() => {
          handleModal(selectedItem);
        }
          " v-bind:search="search" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../ContentHeader";
import * as Constants from "../../js/constants";
import DataTable from "./pageComps/DataTable.vue";
import SearchBar from "./pageComps/Search.vue";
// import Insights from "../layout/Insights.vue";

export default {
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  props: ["organizationData"],
  watch: {
    organizationData: function () {
      //this.communityId = newVal.organization_id
      this.communityId = "nautica2"
      this.performSearch()
    }
  },
  data() {
    return {
      communityId: this.$props.organizationData.organization_id,
      selectedItem: Constants.MAINTENANCE,
      headerName: Constants.MAINTENANCE,
      filters: [],
      tableData: [],
      search: "",
      cardInfo: Constants.DEFAULT_CARD_INFO
    };
  },
  created() {
    this.performSearch("").then((apiData) => {
      console.log("Finished getting and setting API Data", apiData);
    });
  },
  methods: {
    performSearch(data) {
      if (this.communityId == undefined) {
        return
      }
      this.search = data
      let url = `https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/${this.communityId}/maintenance`
      return new Promise((resolve, reject) => {
        fetch(
          url,
          {
            method: `GET`,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            console.log("Search Data", data);
            this.tableData = data.data
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleButtonPress() {
      if (this.communityId == undefined) {
        return
      }
      let decider = true
      if(decider) {
        this.$modal.show(Constants.CREATE_MAINTENANCE_MODAL)
        return
      }
      // const url = `https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/${this.communityId}/maintenance`
      // return new Promise((resolve, reject) => {
      //   fetch(
      //     url,
      //     {
      //       method: `POST`,
      //       headers: {
      //         "Content-Type": "application/json",
      //       },
      //       body: JSON.stringify({
      //         type: "Stove not working - Kitchen",
      //         title: "Someone created an Maintenance Order from Gatewatch at the Front Office",
      //         description: "Maintenance Order Created from Gatewatch",
      //         current_status: "OPEN",
      //         category: "Appliance",
      //         priority: "High",
      //         location: "Kitchen",
      //         reporter: "4474d2f0-06b4-4a8b-b274-12aa154f7822",
      //         resident_uid: "ba831a9a-3efc-4ea6-9ec0-30cf497661e3",
      //         assignee: "ba831a9a-3efc-4ea6-9ec0-30cf497661e3"
      //       })
      //     }
      //   )
      //     .then((res) => res.json())
      //     .then((data) => {
      //       console.log("Create Maintenance Response", data)
      //       resolve(data);
      //     })
      //     .catch((err) => {
      //       reject(err);
      //     });
      //});
    }
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  widows: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
  display: inline;
  margin-right: 16px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.pageHeader button {
  background-color: #1890FFCC;
  color: white;
}

.filterIcon {
  margin-right: 16px;
  display: inline;

}

.iconGroup {
  display: inline;
}
</style>